/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { Route } from '@angular/router';
import { AuthGuard, CguGuard, HomeGuard, MissingFieldsGuard } from '@lcms/shared/data-access-user';
import { SplashScreenComponent } from 'apps/shell/src/app/modules/splash/splash-screen.component';
import { WelcomeComponent } from 'apps/shell/src/app/modules/_metronic/layout/components/welcome/welcome.component';
import {TermsCGUComponent} from "./components/terms-cgu/terms-cgu.component";

export const appRoutes: Route[] = [

  // { path: 'welcome', canActivate: [CguGuard], component: WelcomeComponent },
  {
    path: 'missing-fields',
    loadChildren: () =>
    import('apps/shell/src/app/modules/sso/sso.module').then((m) => m.SsoModule),
  },
  { path: 'CGUser', canMatch: [HomeGuard], component: TermsCGUComponent },
  {
    path: 'error',
    loadChildren: () =>
      import('mfe-error/Module').then((m) => m.RemoteEntryModule),
  },
  {
    path: 'printer',
    loadChildren: () =>
      import('mfe-printer/Module').then((m) => m.AppModule),
  },

  {
    path: '',
    canMatch: [AuthGuard],
    loadChildren: () =>
      import('apps/shell/src/app/modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '',
    canMatch: [HomeGuard],
     canActivate: [CguGuard,MissingFieldsGuard],
    loadChildren: () => import('apps/shell/src/app/modules/_metronic/layout/layout.module').then((m) => m.LayoutModule),
  },
  {
    path: '',
    component: SplashScreenComponent,
  },
  { path: '**', redirectTo: 'error/404' },
];

